<template>
  <div class="container page-Padding">
    <div class="row justify-content-center">
      <div class="col-12 col-md-8">
        <div class="row pt-3">
          <div class="col">
            <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
          </div>
        </div>
        <div class="row justify-content-center" v-if="isLoading">
          <div class="col text-center">
            <mainloader />
          </div>
        </div>
        <div v-else class="card changeAccountType">
          <div class="card-body">
            <div class="row pt-3 steps-wrapper">
              <div class="col-auto text-center">
                <div class="number1">
                  <span class="accountNumber number-Style">1</span>
                  <span class="mx-2 font-color-3E">{{$t('profile.accountType')}}</span>
                  <span class="accountLine"></span>
                </div>
              </div>
              <div class="col-auto text-center">
                <div class="number1">
                  <span :class="(accountType == 'RealEstate_Entity') ? 'accountNumber number-Style': (accountType == 'brokerDetails') ? 'accountNumber number-Style': 'accountNumber'">
                    2
                  </span>
                  <span :class="(accountType == 'RealEstate_Entity') ? 'mx-2 font-color-3E': (accountType == 'brokerDetails') ? 'mx-2 font-color-3E': 'mx-2'">
                    {{$t('profile.accountDetails')}}
                  </span>
                  <span class="accountLine"></span>
                </div>
              </div>
              <div class="col-auto text-center">
                <div class="number1">
                  <span class="accountNumber">3</span>
                  <span class="mx-2">{{$t('profile.accountVerification')}}</span>
                </div>
              </div>
            </div>

            <div class="row pt-3" v-if="accountType == 'changeAccount'">
              <div class="col">
                <div class="row justify-content-center">
                  <div class="col text-center">
                    <div class="accountType" >{{$t('profile.changeAccount_Type')}}</div>
                    <div class="accountType_suitable">{{$t('profile.accountType_suitable')}}</div>
                  </div>
                </div>
                <div class="row justify-content-center pt-3">
                  <div class="col-12 col-md-10 text-center">
                    <div class="warning-styel alert alert-warning" v-if="alertWarning">{{message}}</div>
                  </div>
                </div>
                <div class="row pt-3 justify-content-center">
                  <div class="col-12">
                    <div :class="(accountTypeRequested == 'company') ? 'card cardStyle cardStyleActive': 'card cardStyle'">
                      <div class="card-body position-R">
                        <label class="form-check-label company" for="RealEstateEntity">
                          <div class="row">
                            <div class="col-auto">
                              <img src="/assets/images/icons/Frame-(2).png" class="max-40" alt="">
                            </div>
                            <div class="col p-0">
                              <span class="almarai-bold">{{$t('profile.RealEstate_Entity')}}</span>
                              <div class="accountType_suitable">{{$t('profile.licensed_RealEstate')}}</div>
                            </div>
                            <div class="col-auto d-none d-md-block">
                              <div class="form-check">
                                <input class="form-check-input radio-Account" v-model="accountTypeRequested" name="radioDefault" type="radio" value="company" id="RealEstateEntity">
                              </div>
                            </div>
                          </div>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row pt-3 justify-content-center">
                  <div class="col-12">
                    <div :class="(accountTypeRequested == 'broker') ? 'card cardStyle cardStyleActive': 'card cardStyle'">
                      <div class="card-body position-R">
                        <label class="form-check-label broker" for="Broker">
                          <div class="row">
                            <div class="col-auto">
                              <img src="/assets/images/icons/frame-(1).png" class="max-40" alt="">
                            </div>
                            <div class="col p-0">
                              <span class="almarai-bold">{{$t('profile.realEstate_Broker')}}</span>
                              <div class="accountType_suitable">{{$t('profile.licensed_RealEstate_brokers')}}</div>
                            </div>
                            <div class="col-auto d-none d-md-block">
                              <div class="form-check">
                                <input class="form-check-input radio-Account" name="radioDefault" v-model="accountTypeRequested" type="radio" value="broker" id="Broker">
                              </div>
                            </div>
                          </div>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row pt-3 justify-content-center">
                  <div class="col-12">
                    <div :class="(accountTypeRequested == 'personal') ? 'card cardStyle cardStyleActive': 'card cardStyle'">
                      <div class="card-body position-R">
                        <label class="form-check-label personal" for="personal">
                          <div class="row">
                            <div class="col-auto">
                              <img src="/assets/images/icons/person.png" class="max-40" alt="">
                            </div>
                            <div class="col p-0">
                              <span class="almarai-bold">{{$t('profile.personal')}}</span>
                              <div class="accountType_suitable">{{$t('profile.personalAccount')}}</div>
                            </div>
                            <div class="col-auto content-center d-none d-md-block">
                              <div class="form-check">
                                <input class="form-check-input radio-Account" v-model="accountTypeRequested" name="radioDefault" type="radio" value="personal" id="personal">
                              </div>
                            </div>
                          </div>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row pt-3">
                  <div class="col-12">
                    <div class="card information">
                      <div class="card-body">
                        <div class="row">
                          <div class="col-auto">
                            <img src="/assets/images/icons/Frame.png" class="informationIcon" alt="">
                          </div>
                          <div class="col p-0">
                            <span class="d-none d-md-block">{{$t('profile.importantInformation')}}</span>
                            <div class="font-12">{{$t('profile.detailsReviewed')}}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row pt-4 justify-content-end">
                  <!-- <div class="col-auto buttonBack">
                    {{$t('profile.back')}}
                  </div> -->
                  <div class="col-auto next mx-2"  @click.prevent="changeAccounttype">
                    {{$t('profile.next')}}
                  </div>
                </div>
              </div>
            </div>

            <!-- begin:realEstate_EntityDetails -->
            <div class="row" v-if="accountType == 'RealEstate_Entity'">
              <div class="col">
                <div class="row realEstate_Entity">
                  <div class="col text-center">
                    <div class="accountType">{{$t('profile.realEstate_EntityDetails')}}</div>
                    <div class="accountType_suitable">{{$t('profile.requiredFields')}}</div>
                  </div>
                </div>
                <div class="row justify-content-center pt-3">
                  <div class="col-12 col-md-10 text-center">
                    <div class="warning-styel alert alert-warning" v-if="alertWarning">{{message}}</div>
                  </div>
                </div>
                <div class="row pt-3">
                  <div class="col almarai-bold">
                    1- {{$t('profile.establishmentDetails')}}
                  </div>
                </div>
                <div class="row pt-3">
                  <div class="col-12 col-md-4 units">
                    <label for="" class="text-colorGray">{{$t('profile.commercialRegistration')}}</label>
                    <input type="text" v-model="commercialRegister" 
                      class="form-control bg-inputStyle" :placeholder="$t('profile.enter_Commercialregistration')"
                      maxlength="14" @input="commercialRegister = commercialRegister.replace(/[^0-9]/g, '')"
                    >
                  <div class="">
                    <span class="error-feedback red-color fonttext-14" v-if="bugError">
                      {{ validateMessage }}
                    </span>
                  </div>
                  </div>
                  <div class="col-12 col-md-4 units">
                    <label for="" class="text-colorGray">{{$t('profile.fALLicense_Number')}}</label>
                    <input type="text" v-model="falLicense" 
                      class="form-control bg-inputStyle" :placeholder="$t('profile.enterFallicenseNumber')"
                      maxlength="14" @input="falLicense = falLicense.replace(/[^0-9]/g, '')"
                    >
                  <div class="">
                    <span class="error-feedback red-color fonttext-14" v-if="bugError">
                      {{ validateMessage }}
                    </span>
                  </div>
                  </div>

                  <div class="col-12 col-md-4 units">
                    <label for="" class="text-colorGray">{{$t('profile.expirationDate')}}</label>
                    <datepicker class="form-control bg-inputStyle mouse-hand"
                      v-model="falExpireDate"
                      :clearable="true"
                      :placeholder="$t('profile.licenseExpiration_Date')"
                    />
                  <div class="">
                    <span class="error-feedback red-color fonttext-14" v-if="bugError">
                      {{ validateMessage }}
                    </span>
                  </div>
                  </div>
                </div>
                <!-- <div class="row d-none">
                  <div class="col-4">
                    <span class="error-feedback red-color fonttext-14" v-if="bugError">
                      {{ validateMessage }}
                    </span>
                  </div>
                  <div class="col-4">
                    <span class="error-feedback red-color fonttext-14" v-if="bugError">
                      {{ validateMessage }}
                    </span>
                  </div>
                  <div class="col-4">
                    <span class="error-feedback red-color fonttext-14" v-if="bugError">
                      {{ validateMessage }}
                    </span>
                  </div>
                </div> -->

                <div class="row pt-3">
                  <div class="col-12 col-md-4 units">
                    <label for="" class="text-colorGray ">{{$t('profile.establishment')}}</label>
                    <input type="text" v-model="companyName" 
                      class="form-control bg-inputStyle" :placeholder="$t('profile.enterEstablishment')"
                      maxlength="50" @keypress="charsOnly"
                    >
                    <span class="error-feedback red-color fonttext-14" v-if="bugError">
                      {{ validateMessage }}
                    </span>
                  </div>
                  <div class="col-12 col-md-4 units">
                    <label for="" class="text-colorGray fileds">{{$t('profile.aboutLicensee')}}</label>
                    <input type="text" v-model="bio" maxlength="50" @keypress="charsOnly"
                      class="form-control bg-inputStyle"
                    >
                  </div>

                  <div class="col-12 col-md-4 units">
                    <label for="" class="text-colorGray fileds">{{$t('profile.serviceNumber')}}</label>
                    <input type="text" v-model="companyNumber" class="form-control bg-inputStyle" 
                      placeholder="05xxxxxxxx"  maxlength="10" @input="companyNumber = companyNumber.replace(/[^0-9]/g, '')"
                    >
                  </div>
                </div>

                <div class="row pt-3">
                  <div class="col almarai-bold">
                    2- {{$t('profile.uploadingRequiredDocuments')}}
                  </div>
                </div>
                <div class="row pt-3 justify-content-center d-none d-md-block">
                  <div class="col-12">
                    <div class="card cardStyle">
                      <div class="card-body">
                        <div class="row">
                          <div class="col-auto btn-uploadFile">
                            <label class="form-check-label d-block" for="uploadFile">
                              <input type="file" @change="uploadFalLicense($event.target.files)" multiple class="form-control d-none" id="uploadFile">
                              <img src="/assets/images/icons/downloadI.png" class="max-24" alt="">
                              <span class="mx-2">{{$t('profile.clickUploadFile')}}</span>
                            </label>
                          </div>
                          <div class="col">
                            <span class="almarai-bold">{{$t('profile.licenseIssued')}}</span>
                            <div class="accountType_suitable">{{$t('profile.fileMustbe')}}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="error-feedback red-color fonttext-14" v-if="bugError">
                    {{ validateMessage }}
                  </div>
                </div>

                <div class="row pt-3 justify-content-center d-block d-md-none">
                  <div class="col-12">
                    <div class="card cardStyle">
                      <div class="card-body position-R">
                        <label class="form-check-label d-block" for="uploadFile">
                          <div class="row">
                            <div class="col">
                              <span class="almarai-bold">{{$t('profile.FalLicense')}}</span>
                              <div class="accountType_suitable">{{$t('profile.clickUploadFile')}}</div>
                            </div>
                            <div class="col-auto content-center">
                              <input type="file" class="form-control d-none" id="uploadFile"
                                @change="uploadFalLicense($event.target.files)" multiple
                              >
                              <img src="/assets/images/icons/download_Icon.png" class="max-40" alt="">
                            </div>
                          </div>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="error-feedback red-color fonttext-14" v-if="bugError">
                    {{ validateMessage }}
                  </div>
                </div>

                <div class="row pt-3 justify-content-center d-none d-md-block">
                  <div class="col-12">
                    <div class="card cardStyle">
                      <div class="card-body">
                        <div class="row">
                          <div class="col-auto btn-uploadFile">
                            <label class="form-check-label d-block" for="commercialRegistration">
                              <input type="file" @change="uploadFile($event.target.files)" multiple class="form-control d-none" id="commercialRegistration">
                              <img src="/assets/images/icons/downloadI.png" class="max-24" alt="">
                              <span class="mx-2">{{$t('profile.clickUploadFile')}}</span>
                            </label>
                          </div>
                          <div class="col">
                            <span class="almarai-bold">{{$t('profile.commercialRegistrationissued')}}</span>
                            <div class="accountType_suitable">{{$t('profile.pleaseAttach')}}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="error-feedback red-color fonttext-14" v-if="bugError">
                    {{ validateMessage }}
                  </div>
                </div>

                <div class="row pt-3 justify-content-center d-block d-md-none">
                  <div class="col-12">
                    <div class="card cardStyle">
                      <div class="card-body position-R">
                        <label class="form-check-label d-block" for="commercialRegistration">
                          <div class="row">
                            <div class="col">
                              <span class="almarai-bold">{{$t('profile.commercialRegistrat_image')}}</span>
                              <div class="accountType_suitable">{{$t('profile.clickUploadFile')}}</div>
                            </div>
                            <div class="col-auto content-center">
                              <input type="file" @change="uploadFile($event.target.files)" multiple class="form-control d-none" id="commercialRegistration">
                              <img src="/assets/images/icons/download_Icon.png" class="max-40" alt="">
                            </div>
                          </div>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="error-feedback red-color fonttext-14" v-if="bugError">
                    {{ validateMessage }}
                  </div>
                </div>
                
                <!-- bengin: upload Company Logo -->
                <div class="row pt-3 justify-content-center d-none d-md-block">
                  <div class="col-12">
                    <div class="card cardStyle">
                      <div class="card-body">
                        <div class="row">
                          <div class="col-auto btn-uploadFile">
                            <label class="form-check-label d-block" for="companyLogo">
                              <input type="file" @change="uploadCompanylogo($event.target.files)" multiple class="form-control d-none" id="companyLogo">
                              <img src="/assets/images/icons/downloadI.png" class="max-24" alt="">
                              <span class="mx-2">{{$t('profile.clickUploadFile')}}</span>
                            </label>
                          </div>
                          <div class="col">
                            <span class="almarai-bold">{{$t('profile.companyLogo')}}</span>
                            <div class="accountType_suitable">{{$t('profile.companyLogoAttach')}}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row pt-3 justify-content-center d-block d-md-none">
                  <div class="col-12">
                    <div class="card cardStyle">
                      <div class="card-body position-R">
                        <label class="form-check-label d-block" for="companyLogo">
                          <div class="row">
                            <div class="col">
                              <span class="almarai-bold">{{$t('profile.companyLogo')}}</span>
                              <div class="accountType_suitable">{{$t('profile.clickUploadFile')}}</div>
                            </div>
                            <div class="col-auto content-center">
                              <input type="file" @change="uploadCompanylogo($event.target.files)" multiple class="form-control d-none" id="companyLogo">
                              <img src="/assets/images/icons/download_Icon.png" class="max-40" alt="">
                            </div>
                          </div>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="error-feedback red-color fonttext-14" v-if="bugError">
                    {{ validateMessage }}
                  </div>
                </div>

                <div class="row pt-4">
                  <div class="col-12">
                    <div class="card information">
                      <div class="card-body">
                        <div class="row">
                          <div class="col-auto">
                            <img src="/assets/images/icons/Frame.png" class="informationIcon" alt="">
                          </div>
                          <div class="col p-0">
                            <span class="d-none d-md-block">{{$t('profile.importantInformation')}}</span>
                            <div class="font-12">{{$t('profile.pleaseEnsure')}}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row pt-4 justify-content-end">
                  <div class="col-auto buttonBack" @click.prevent="prevPage">
                    {{$t('profile.back')}}
                  </div>
                  <div class="col-auto next mx-2" @click.prevent="changeAccount">
                    {{$t('profile.submitRequest')}}
                  </div>
                </div>
              </div>
            </div>
            <!-- end:realEstate_EntityDetails -->

            <!-- begin:realEstate Broker Details -->
            <div class="row" v-if="accountType == 'brokerDetails'">
              <div class="col">
                <div class="row pt-5 justify-content-center">
                  <div class="col text-center">
                    <div class="accountType">{{$t('profile.realEstateBrokerDetails')}}</div>
                    <div class="accountType_suitable">{{$t('profile.requiredFields')}}</div>
                  </div>
                </div>

                <div class="row justify-content-center pt-3">
                  <div class="col-12 col-md-10 text-center">
                    <div class="warning-styel alert alert-warning" v-if="alertWarning">{{message}}</div>
                  </div>
                </div>

                <div class="row pt-3">
                  <div class="col almarai-bold">
                    1- {{$t('profile.basicLicense_Information')}}
                  </div>
                </div>
                <div class="row pt-3">
                  <div class="col-12 col-md-6 units">
                    <label for="" class="text-colorGray">{{$t('profile.fALLicense_Number')}}</label>
                    <input type="text" v-model="falLicense" 
                      class="form-control bg-inputStyle" :placeholder="$t('profile.enterFallicenseNumber')"
                      maxlength="12" @input="falLicense = falLicense.replace(/[^0-9]/g, '')"
                    >
                    <div class="error-feedback red-color fonttext-14" v-if="bugError">
                      {{ validateMessage }}
                    </div>
                  </div>
                  <div class="col-12 col-md-6 units">
                    <label for="" class="text-colorGray">{{$t('profile.expirationDate')}}</label>
                    <datepicker class="form-control bg-inputStyle mouse-hand"
                      v-model="falExpireDate"
                      :clearable="true"
                      :placeholder="$t('profile.licenseExpiration_Date')"
                    />
                    <div class="error-feedback red-color fonttext-14" v-if="bugError">
                      {{ validateMessage }}
                    </div>
                  </div>
                </div>

                <div class="row pt-2">
                  <div class="col-12 col-md-6 units">
                    <label for="" class="text-colorGray fileds">{{$t('profile.aboutLicensee')}}</label>
                    <input type="text" v-model="bio" maxlength="50" @keypress="charsOnly"
                      class="form-control bg-inputStyle"
                    >
                  </div>

                  <div class="col-12 col-md-6 units">
                    <label for="" class="text-colorGray fileds">{{$t('profile.serviceNumber')}}</label>
                    <input type="text" v-model="companyNumber" class="form-control bg-inputStyle" 
                      placeholder="05xxxxxxxx"  maxlength="10" @input="companyNumber = companyNumber.replace(/[^0-9]/g, '')"
                    >
                  </div>
                </div>

                <div class="row pt-3">
                  <div class="col almarai-bold">
                    2- {{$t('profile.uploadingRequiredDocuments')}}
                  </div>
                </div>
                <div class="row pt-3 justify-content-center d-none d-md-block">
                  <div class="col-12">
                    <div class="card cardStyle">
                      <div class="card-body">
                        <div class="row">
                          <div class="col-auto btn-uploadFile">
                            <label class="form-check-label mouse-hand" for="falLicense">
                              <input type="file" class="form-control d-none" id="falLicense" @change="uploadFalLicense($event.target.files)" multiple>
                              <img src="/assets/images/icons/downloadI.png" class="max-24" alt="">
                              <span class="mx-2">{{$t('profile.clickUploadFile')}}</span>
                            </label>
                          </div>
                          <div class="col">
                            <span class="almarai-bold">{{$t('profile.licenseIssued')}}</span>
                            <div class="accountType_suitable">{{$t('profile.fileMustbe')}}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="error-feedback red-color fonttext-14" v-if="bugError">
                    {{ validateMessage }}
                  </div>
                </div>

                <div class="row pt-3 justify-content-center d-block d-md-none">
                  <div class="col-12">
                    <div class="card cardStyle">
                      <div class="card-body position-R">
                        <label class="form-check-label d-block" for="falLicense">
                          <div class="row">
                            <div class="col mouse-hand">
                              <span class="almarai-bold">{{$t('profile.FalLicense')}}</span>
                              <div class="accountType_suitable">{{$t('profile.clickUploadFile')}}</div>
                            </div>
                            <div class="col-auto content-center">
                              <input type="file" class="form-control d-none" @change="uploadFalLicense($event.target.files)" multiple id="falLicense">
                              <img src="/assets/images/icons/download_Icon.png" class="max-40" alt="">
                            </div>
                          </div>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="error-feedback red-color fonttext-14" v-if="bugError">
                    {{ validateMessage }}
                  </div>
                </div>

                <div class="row pt-4">
                  <div class="col-12">
                    <div class="card information">
                      <div class="card-body">
                        <div class="row">
                          <div class="col-auto">
                            <img src="/assets/images/icons/Frame.png" class="informationIcon" alt="">
                          </div>
                          <div class="col p-0">
                            <span class="d-none d-md-block">{{$t('profile.importantInformation')}}</span>
                            <div class="font-12">{{$t('profile.pleaseEnsure')}}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row pt-4 justify-content-end">
                  <div class="col-auto buttonBack" @click.prevent="prevPage">
                    {{$t('profile.back')}}
                  </div>
                  <div class="col-auto next mx-2" @click.prevent="changeAccount">
                    {{$t('profile.submitRequest')}}
                  </div>
                </div>
              </div>
            </div>
            <!-- end:realEstate Broker Details -->
          </div>
        </div>
      </div>
    </div>
    
    <!-- begin: alert change account -->
    <div class="modal bg-modal" id="changeAccountPopup" tabindex="-1">
      <div class="modal-dialog  modal-Max320">
        <div class="modal-content">
          <div class="modal-body">
            <!-- <img src="/assets/images/icons/Error.png" class="width-48" alt=""> -->
            <div class="row justify-content-center pt-3">
              <div class="col text-center">
                <p class="dataSent">{{$t('profile.alert')}}</p>
                <h6 class="fontGray-73 ibm-plex-regular">{{$t('profile.changeyour_Account')}}</h6>
              </div>
            </div>
            <div class="row py-2 justify-content-center">
              <div class="col-auto btn-blackSmall" @click="changeAccountFN">
                {{$t('addAd.yes')}}
              </div>
              <div class="col-auto btn-whiteSmall" @click="closePopup">
                {{$t('addAd.no')}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end: alert change account -->

    <!-- bengin:request sent successfully -->
    <div class="modal bg-modal" tabindex="-1" id="requestSuccessfully">
      <div class="modal-dialog max-400">
        <div class="modal-content">
          <div class="modal-body">
            <div class="row justify-content-center">
              <div class="col text-center">
                <img src="/assets/images/icons/tick-circle-1.png" class="max-50" alt="">
              </div>
            </div>
            <div class="row justify-content-center pt-3">
              <div class="col text-center">
                <p class="dataSent">{{$t('profile.dataSent')}}</p>
                <h6 class="fontGray-73 ibm-plex-regular">{{$t('profile.successfullySubmitted')}}</h6>
              </div>
            </div>
            <div class="row pt-3 justify-content-center">
              <div class="col-12 col-md-8 text-center">
                <router-link :to="`/portfolio/${GET_USER_DATA.userCode}`">
                  <div class="btn-green ibm-plex-bold">{{$t('profile.myAccount')}}</div>
                </router-link>
              </div>
            </div>
            <div class="row py-3 justify-content-center">
              <div class="col-12 col-md-8 text-center ibm-plex-bold">
                <router-link to="/">
                  <div>
                    {{$t('profile.homePage')}}
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end:request sent successfully -->
  </div>  
</template>
<script>
// import { useVuelidate } from '@vuelidate/core';
// import { required } from '@vuelidate/validators';
import Datepicker from 'vue3-datepicker';
import { mapGetters } from 'vuex';
export default {
  name: 'accountType',
  // setup(){
  //   return { validate: useVuelidate() }
  // },
  computed: {
    ...mapGetters(['GET_USER_DATA'])
  },
  data(){
    return{
      hasError: false,
      isLoading: false,
      message: "",
      errorNumber: 0,
      accountType: "changeAccount",
      accountTypeRequested: '',
      companyName: "",
      commercialRegister: null,
      commercialRegisterFile: "",
      falLicense: null,
      falExpireDate: null,
      falFile: "",
      logo: "",
      companyNumber: "",
      bio: "",
      validateMessage: this.$t('validateMessage'),
      alertWarning: false,
      bugError: false,
      errorMessage: "",
    }
  },
  // validations (){
  //   return {
  //     companyObj:{
  //       falLicense: {required}, falExpireDate: {required},
  //       commercialRegister: {required},
  //       commercialRegisterFile: {required},
  //       falFile: {required},
  //       companyName: {required},
  //     },
  //     brokerObj:{
  //       falLicense: {required},
  //       falExpireDate: {required},
  //       falFile: {required},
  //     }
  //   }
  // },
  components: {
    Datepicker,
  },
  methods: {
    async changeAccounttype(){
      if(!this.accountTypeRequested){
        this.message = "يجب اختيار نوع الحساب "
        this.alertWarning = true;
        window.scrollTo({top:0, behavior:'smooth'});
        return false;
      }
      if(this.accountTypeRequested){
        this.message = '';
        this.alertWarning = false;
      }
      if(this.accountTypeRequested == 'company'){
        this.accountType = 'RealEstate_Entity';
        window.scrollTo({top:0, behavior:'smooth'});
      }else{
        if(this.accountTypeRequested == 'broker'){
          this.accountType = 'brokerDetails';
          window.scrollTo({top:0, behavior:'smooth'});
        }
      }
      if(this.accountTypeRequested == 'personal'){
        document.getElementById('changeAccountPopup').style.display = 'block';
        return false;
      }
    },

    // function change your Account type
    async changeAccount(){
      this.hasError = false;
      this.bugError = false;
      if(this.accountTypeRequested == 'company' && this.accountType == 'RealEstate_Entity'){
        if(!this.falLicense){
          this.errorMessage = this.validateMessage;
          this.bugError = true;
          window.scrollTo({top:0, behavior: 'smooth'});
          return false;
        }
        if(!this.falExpireDate){
          this.errorMessage = this.validateMessage;
          this.bugError = true;
          window.scrollTo({top:0, behavior: 'smooth'});
          return false;
        }
        if(!this.falFile){
          this.errorMessage = this.validateMessage;
          this.bugError = true;
          window.scrollTo({top:0, behavior: 'smooth'});
          return false;
        }
        if(!this.commercialRegister){
          this.errorMessage = this.validateMessage;
          this.bugError = true;
          window.scrollTo({top:0, behavior: 'smooth'});
          return false;
        }
        if(!this.commercialRegisterFile){
          this.errorMessage = this.validateMessage;
          this.bugError = true;
          window.scrollTo({top:0, behavior: 'smooth'});
          return false;
        }
        if(!this.companyName){
          this.errorMessage = this.validateMessage;
          this.bugError = true;
          window.scrollTo({top:0, behavior: 'smooth'});
          return false;
        }

        if(this.companyNumber && !this.companyNumber.startsWith('05')){
          this.alertWarning = false;
          this.message = this.$t('incorrectMobile');
          this.alertWarning = true;
          window.scrollTo({top:0, behavior:'smooth'});
          return false;
        }
      }

      if(this.accountTypeRequested == 'broker' && this.accountType == 'brokerDetails'){
        if(!this.falLicense){
          this.errorMessage = this.validateMessage;
          this.bugError = true;
          window.scrollTo({top:0, behavior: 'smooth'});
          return false;
        }
        if(!this.falExpireDate){
          this.errorMessage = this.validateMessage;
          this.bugError = true;
          window.scrollTo({top:0, behavior: 'smooth'});
          return false;
        }
        if(!this.falFile){
          this.errorMessage = this.validateMessage;
          this.bugError = true;
          window.scrollTo({top:0, behavior: 'smooth'});
          return false;
        }

        if(this.companyNumber && !this.companyNumber.startsWith('05')){
          this.message = this.$t('incorrectMobile');
          this.hasError = true;
          window.scrollTo({top:0, behavior:'smooth'});
          return false;
        }
      }
      this.isLoading = true;
      const formData = new FormData();
      formData.append("accountTypeRequested", this.accountTypeRequested);
      formData.append("falLicense", this.falLicense);
      formData.append("commercialRegister", this.commercialRegister);
      formData.append("falExpireDate", this.falExpireDate);
      formData.append("falFile", this.falFile);
      formData.append("commercialRegisterFile", this.commercialRegisterFile);
      formData.append("companyName", this.companyName);
      formData.append("logo", this.logo);
      formData.append("companyNumber", this.companyNumber);
      formData.append("bio", this.bio);
      this.$http.post('/api/accountDetails/set',formData).then(res=> {
        // console.log(res);
        document.getElementById('requestSuccessfully').style.display = 'block';
        this.isLoading = false;
      }).catch(err => {
        this.isLoading = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({top:0, behavior:'smooth'});
      })
    },

    uploadFile(files) {
      this.commercialRegisterFile = files[0];
    },
    uploadFalLicense(files) {
      this.falFile = files[0];
    },
    uploadCompanylogo(files) {
      this.logo = files[0];
    },

    charsOnly(e) {
      const char = e.key;
      const allowed = /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FFA-Za-z\s]$/;

      if (!allowed.test(char)) {
        e.preventDefault(); // block the input
      }
    },

    prevPage(){
      this.accountType ='changeAccount';
    },

    closePopup(){
      document.getElementById('changeAccountPopup').style.display = 'none';
    },
    changeAccountFN(){
      document.getElementById('changeAccountPopup').style.display = 'none';
      this.changeAccount();
    }
  },
  created(){
    window.scrollTo({top:0, behavior:'smooth'});
  }
}
</script>